module.exports = __webpack_public_path__ + "img/Sue.b480a144.svg";